import { inject, Injectable } from '@angular/core';
import { GlobalInfo } from '../../model';
import { AsyncHttpClient } from './async-http-client.service';

@Injectable({ providedIn: 'root' })
export class GlobalService {
  private readonly http = inject(AsyncHttpClient);

  info = async () => {
    const info = await this.http.get<GlobalInfo>('api/global');
    return {
      ...info,
      resolveStates: (countryId: string) => {
        const country = info.countries.find(({ short }) => short === countryId);
        return (
          country?.regions?.map((i) => {
            const name = i.name.startsWith(country.name + ' - ') ? i.name.substring(country.name.length + 3) : i.name;
            return { ...i, name };
          }) || []
        );
      },
    } as GlobalInfo;
  };
}
